import React, {useContext} from 'react';
import Typography from '@material-ui/core/Typography';
import StatisticBox from '../../../../components/common/statistic-box/StatisticBox';
import {styled} from '@material-ui/core/styles';
import {HeaderSkeleton, ParagraphSkeleton} from '../../../../components';
import {CloseAccountContext} from '../..';
import {useGetMessages} from '../../../../hooks';
import {isPayoutThresholdEligible} from '../../../../utils/ValidationUtils';
import {Grid, GridItem} from './styles';

const Box = styled('div')(({theme}) => ({
    '& > *': {
        marginBottom: theme.spacing(4)
    }
}));

export interface AreYouSureProps {
    amount?: string | number;
}

const AreYouSure: React.FC<AreYouSureProps> = props => {
    const {isRendering, amount = 0} = useContext(CloseAccountContext);
    const hasEligibleBalance = isPayoutThresholdEligible(amount);
    const messages = useGetMessages({
        header: 'epic.affiliate.closeAccount.areYouSure.v2',
        desc: 'epic.affiliate.closeAccount.areYouSure.default.v2',
        descWithPayout: 'epic.affiliate.closeAccount.areYouSure.withPayout.v2',
        eligibleAmount: 'epic.affiliate.closeAccount.eligibleAmount.v2'
    });

    const desc = messages.desc + (hasEligibleBalance ? ` ${messages.descWithPayout}` : '');

    return (
        <Box>
            {isRendering ? (
                <>
                    <HeaderSkeleton variant="h5" height={30} width={250} />
                    <ParagraphSkeleton type="sm" />
                </>
            ) : (
                <>
                    <Typography variant="h5">{messages.header}</Typography>
                    <Typography variant="body1">{desc}</Typography>
                </>
            )}
            {hasEligibleBalance && (
                <Grid>
                    <GridItem>
                        <StatisticBox
                            type="currency"
                            header={amount}
                            subHeader={messages.eligibleAmount}
                            isRendering={isRendering}
                        />
                    </GridItem>
                </Grid>
            )}
        </Box>
    );
};

export default AreYouSure;
